import { tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 0 20px 20px 20px;
  margin-bottom: 30px;
`;

export const PropertiesTag = styled.p`
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${(props) => props.theme.primary};
  color: ${(props) => props.theme.white};
  padding: 4px;
  border-radius: 8px 0 8px 0;
`;

export const AgentLogo = styled.img`
  height: 50px;
`;

export const Content = styled.div`
  display: flex;
  margin-top: 15px;
  justify-content: space-between;

  @media (${tabletMax}) {
    flex-direction: column;
  }
`;

export const ButtonBox = styled.div`
  @media (${tabletMax}) {
    margin-top: 15px;
  }
`;

export const InfoRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 15px;

  p,
  a {
    margin-left: 10px;
  }
`;

export const Accreditations = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  flex-direction: row;
  margin-top: 15px;

  a {
    margin-right: 15px;
    margin-bottom: 10px;
  }

  img {
    max-height: 50px;
  }
`;
